import Modal from "../Modal"
import { StatusBadge } from "./StatusBadge"
import Button from "../Button"

export const ProgressionCheckModal = ({ isOpen, onClose, checkData }) => {
  if (!checkData) return null

  const canProgress = checkData.can_progress
  const hasBlockers = checkData.blockers && checkData.blockers.length > 0

  return (
    <Modal isOpen={isOpen} setIsOpen={onClose} width="md:max-w-2xl">
      <div className="flex flex-col gap-6">
        <div className="text-center">
          {canProgress ? (
            <i className="fa-solid fa-circle-check text-6xl text-green-500 mb-4"></i>
          ) : (
            <i className="fa-solid fa-circle-xmark text-6xl text-red-500 mb-4"></i>
          )}
          <h2 className="text-2xl font-bold text-brandSecondary">
            {canProgress ? "Can Progress" : "Cannot Progress"}
          </h2>
        </div>

        <div className="space-y-4">
          <div className="flex items-center justify-center gap-4">
            <div className="text-center">
              <div className="text-sm text-gray-600 mb-1">Current Status</div>
              <StatusBadge status={checkData.current_status} />
            </div>
            <i className="fa-solid fa-arrow-right text-gray-400 text-2xl"></i>
            <div className="text-center">
              <div className="text-sm text-gray-600 mb-1">Next Status</div>
              {checkData.next_status ? (
                <StatusBadge status={checkData.next_status} />
              ) : (
                <span className="text-gray-400">None</span>
              )}
            </div>
          </div>

          {hasBlockers && (
            <div className="bg-red-50 border border-red-200 rounded-lg p-4">
              <h3 className="font-bold text-red-800 mb-2">Blockers:</h3>
              <ul className="list-disc list-inside space-y-1">
                {checkData.blockers.map((blocker, index) => (
                  <li key={index} className="text-red-700 text-sm">
                    {blocker}
                  </li>
                ))}
              </ul>
            </div>
          )}

          {checkData.requirements_met && (
            <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
              <h3 className="font-bold text-gray-800 mb-2">Requirements:</h3>
              <div className="grid grid-cols-2 gap-2 text-sm">
                {Object.entries(checkData.requirements_met).map(([key, met]) => (
                  <div key={key} className="flex items-center gap-2">
                    <i className={`fa-solid ${met ? 'fa-check text-green-600' : 'fa-times text-red-600'}`}></i>
                    <span className={met ? 'text-gray-700' : 'text-gray-500'}>
                      {key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className="flex justify-center">
          <Button onClick={onClose} variant="secondary">
            Close
          </Button>
        </div>
      </div>
    </Modal>
  )
}
